export type FilterValue =
  | null
  | string
  | boolean
  | number
  | undefined
  | string[]
  | boolean[]
  | number[]
  | Record<string, unknown>;
export type NextFilters<T> = Partial<T>;
export type WithPagination<T> = T & {
  page: number;
};
export type StoredFilters<T> = Record<string, { data: NextFilters<T> }>;
